import React from "react";
import { assetsPath } from "../../../../../utils";

const baseAssetUrl = assetsPath("laguna-seaside-residences");

export default ({ currentLang, selectedType, selectedBuilding }) => {
  const BG = `${baseAssetUrl}/images/site-plan/${currentLang}/5.png`;
  const shouldDisplay = (build, type) => {
    return (selectedType === type || selectedType === "all") &&
      (selectedBuilding === build || selectedBuilding === "all")
      ? "opacity-in"
      : "opacity-out";
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 800 500"
      data-name="Layer 1"
      className="site-plan-svg"
    >
      <g id="map">
        <image xlinkHref={BG} height="100%" width="100%" />
      </g>
      <g id="floorplan">
        <g className="building-a">
          <g id="1-bed" className={shouldDisplay("a", "1-bed")}>
            <rect
              x="142.78"
              y="292.06"
              width="63.83"
              height="37.85"
              transform="translate(-10.81 6.32) rotate(-2.01)"
            />
            <rect
              x="208.3"
              y="289.48"
              width="63.57"
              height="38.31"
              transform="matrix(1, -0.04, 0.04, 1, -10.69, 8.62)"
            />
            <rect
              x="277.77"
              y="283.51"
              width="62.44"
              height="37.85"
              transform="translate(-10.43 11.03) rotate(-2.01)"
            />
            <rect
              x="341.85"
              y="281.34"
              width="61.72"
              height="37.85"
              transform="translate(-10.31 13.27) rotate(-2.01)"
            />
            <rect
              x="405.16"
              y="279.16"
              width="62.21"
              height="37.85"
              transform="translate(-10.2 15.5) rotate(-2.01)"
            />
          </g>
          <g id="2-bed" className={shouldDisplay("a", "2-bed")}>
            <polygon points="624.7 277.73 558.35 277.91 558.35 218.55 624.26 218.55 624.7 277.73" />
            <polygon points="477.1 268.1 409.37 270.62 407.32 211.3 474.6 208.97 477.1 268.1" />
            <polygon points="547.68 277.54 479.8 280.06 477.75 220.74 545.19 218.41 547.68 277.54" />
          </g>
          <g id="3-bed" className={shouldDisplay("a", "3-bed")}>
            <rect
              x="115.24"
              y="219.54"
              width="89.23"
              height="59.79"
              transform="translate(-8.62 5.74) rotate(-2)"
            />
            <rect
              x="206.19"
              y="216.27"
              width="89.23"
              height="59.79"
              transform="matrix(1, -0.03, 0.03, 1, -8.45, 8.91)"
            />
            <rect
              x="306.66"
              y="212.73"
              width="89.23"
              height="59.79"
              transform="translate(-8.26 12.42) rotate(-2)"
            />
            <rect x="627.06" y="218.44" width="88.75" height="59.11" />
          </g>
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/data/LagunaSeasideResidences/sitePlan/svg/floor/5.js